import { render, staticRenderFns } from "./InvestingPage.vue?vue&type=template&id=a2bdd68c&scoped=true&"
import script from "./InvestingPage.vue?vue&type=script&lang=js&"
export * from "./InvestingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bdd68c",
  null
  
)

export default component.exports